export const appConfig = {
    MODE: import.meta.env.MODE,
    LOGIN_URL: import.meta.env.VITE_LOGIN_URL,
    LOGIN_CLIENT_ID: import.meta.env.VITE_LOGIN_CLIENT_ID,
    API_URL: import.meta.env.VITE_API_URL,
    API_KEY: import.meta.env.VITE_API_KEY,
    MATKONTO_CLIENT_ID: import.meta.env.VITE_MATKONTO_CLIENT_ID,
    HANDLA_REDIRECT_URL: import.meta.env.VITE_HANDLA_REDIRECT_URL,
};
